import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute } from "@angular/router";
import { DataService } from '../data.service';

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css']
})
export class FormularioComponent {
  items: MenuItem[];
  activeItem: MenuItem;
  id: string;
  idencuesta: string;
  usuario;
  encuestas;
  encuestaSeleccionada;

  constructor(public data: DataService, private route: ActivatedRoute) {

    this.data.encuestaSeleccionada$.subscribe(valor => {
      this.encuestaSeleccionada = valor ?? '';
    });

    this.id = this.route.snapshot.paramMap.get('id');
    console.log("=================== id &&&&&&&&&&&&&&&&&&");
    console.log(this.id);
    this.idencuesta = this.route.snapshot.paramMap.get('idencuesta');
    console.log("=================== idencuesta &&&&&&&&&&&&&&&&&&");
    console.log(this.idencuesta);

    this.data.ObtenerEncuestas(this.route.snapshot.paramMap.get('id')).subscribe(resencuestas => {

      this.encuestas = resencuestas.map((x) => {
        return { label: x.Nombre, value: x._id }
      });
      this.encuestaSeleccionada=this.encuestas[0].value;
      this.data.setEncuestaSeleccionada(this.encuestaSeleccionada);


    })
   

}

actualizarLista(){
  this.data.ObtenerEncuestas(this.route.snapshot.paramMap.get('id')).subscribe(resencuestas => {

    this.encuestas = resencuestas.map((x) => {
      return { label: x.Nombre, value: x._id }
    });
    this.encuestaSeleccionada=this.encuestas[0].value;
    this.data.setEncuestaSeleccionada(this.encuestaSeleccionada);


  })
}

  ngOnInit() {

    this.usuario=this.data.ObtenerUsuario();

    this.route.params.subscribe(params => {
      this.id = params['id']; // Obtiene el nuevo ID de la URL

      var esAdmin = this.usuario.Rol=="admin"?true:false;

      if(this.id){

        if(esAdmin)
        {
          this.items = [
          { label: 'Propiedades', icon: 'pi pi-fw pi-cog' }, // Ícono de configuración para propiedades
          //Opcion formulario
          { label: 'Formulario', icon: 'pi pi-fw pi-file' }, // Ícono de archivo para formularios
          { label: 'Encuestas', icon: 'pi pi-fw pi-file-edit' }, // Ícono de cuestionario para encuestas
          { label: 'Resultados', icon: 'pi pi-fw pi-chart-bar' }, // Ícono de gráfica para resultados
          { label: 'Precargar', icon: 'pi pi-fw pi-upload' }, // Ícono de subir para precargar
          // { label: 'Devolver', icon: 'pi pi-fw pi-undo' }, // Ícono de deshacer para devolver
          { label: 'Usuarios', icon: 'pi pi-fw pi-users' }, // Ícono de usuarios para la sección de usuarios
          { label: 'Estadísticas', icon: 'pi pi-fw pi-chart-line' } // Ícono de línea de gráficos para estadísticas
          ];
        }
        else
        {
          this.items = [
            { label: 'Propiedades', icon: 'pi pi-fw pi-cog' }, // Ícono de configuración para propiedades
            //Opcion formulario            
            { label: 'Encuestas', icon: 'pi pi-fw pi-file-edit' }, // Ícono de cuestionario para encuestas
            { label: 'Resultados', icon: 'pi pi-fw pi-chart-bar' }, // Ícono de gráfica para resultados
            { label: 'Precargar', icon: 'pi pi-fw pi-upload' }, // Ícono de subir para precargar
            // { label: 'Devolver', icon: 'pi pi-fw pi-undo' }, // Ícono de deshacer para devolver            
            { label: 'Estadísticas', icon: 'pi pi-fw pi-chart-line' } // Ícono de línea de gráficos para estadísticas
            ];
        }


      }
      else
      {    this.items = [
        { label: 'Propiedades', icon: 'pi pi-fw pi-cog' } // Ícono de configuración para propiedades
      ];}

    });




    if(this.idencuesta){
      this.activeItem = this.items[2];
    }
    else{
      this.activeItem = this.items[0];
    }

    // this.route.params.subscribe(params => {
    //   this.id = params['id'];
    //   this.idencuesta = params['idencuesta'];
    //   this.activeItem = this.items[2];
    // });


    
  }

  onEncuestaCambiada(valor: string) {
    this.encuestaSeleccionada = valor;
    this.data.setEncuestaSeleccionada(valor);
  }

onActiveItemChange(event){
  this.activeItem = event;
}

activateLast() {
  this.activeItem = this.items[this.items.length - 1];
}
onVerResultados(idencuesta: string) {
  //alert('Ver resultados de encuesta ' + idencuesta);
  this.idencuesta = idencuesta;
  const item = this.items.find(x => x.label === 'Resultados');
  this.activeItem = item;

  this.data.setEncuestaSeleccionada(idencuesta);
  //
}
}
